import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "@actions/actionCreators";

type Args = {
  portalItemId: string;
  portalId: string;
};

const [useDeletePortalItem, deletePortalItem] = createAsyncAction(
  "portalItems/delete",
  async (args: Args) => {
    const res = await API.call<{ portalItem: string }>({
      endpoint: `portal_items/${args.portalItemId}`,
      method: "DELETE",
    });
    return { ...res, result: res.result.portalItem };
  }
);

export default useDeletePortalItem;
export { deletePortalItem };
